// extracted by mini-css-extract-plugin
module.exports = {"mainSection":"seo-page_mainSection__d22Sp","cta":"seo-page_cta__GB_Sl"};